import React from 'react'
import PropTypes from 'prop-types'
import AddButton from '../AddButton'
import styles from './UserImproveLine.icss'
import ImproveLine from '../ImproveLine'

class UserImproveLine extends React.Component {
	render() {
		const { className, handleEdit, label, ...rest } = this.props
		return (
			<ImproveLine className={className} text={this.context.translate('Want to compare?')} {...rest}>
				<div className={styles.buttonLine}>
					<AddButton onClick={handleEdit} className={styles.addButton}>{label}</AddButton>
				</div>
			</ImproveLine>
		)
	}
}

UserImproveLine.contextTypes = {
	translate: PropTypes.func
}

UserImproveLine.propTypes = {
	handleEdit: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	className: PropTypes.string
}

UserImproveLine.defaultProps = {
	className: undefined
}

export default UserImproveLine



// WEBPACK FOOTER //
// ./src/components/User/UserImproveLine.jsx